import React from "react";

import Adobe from "./images/Adobe";
import Figma from "./images/Figma";
import GDocs from "./images/GDocs";
import GSlides from "./images/GSlides";
import PowerPoint from "./images/PowerPoint";
import Sketch from "./images/Sketch";
import Windows from "./images/Windows";
import Word from "./images/Word";

import ILLUSTRATOR_LOGO from "./images/illustrator.png";
import PHOTOSHOP_LOGO from "./images/photoshop.png";
import INDESIGN_LOGO from "./images/indesign.png";
import {
    FOR_ADOBE_PATH,
    FOR_GOOGLE_PATH,
    FOR_MAC_PATH,
    FOR_OFFICE_PATH,
    homePath
} from "data/links";

export const subText =
    "Enjoy unlimited access to millions of icons from the Noun Project website or directly in your workflow with our app and plugins.";

export const button = [
    {
        text: "Continue",
        url: homePath.url
    }
];

export const boxHeading =
    "Your Subscription Unlocks Unlimited Use Of Our App and Plugins";
export const boxes = [
    {
        heading: "Noun Project for Mac",
        text:
            "Drag icons into almost any Mac experience: Sketch, Creative Cloud, Google, Office, more.",
        images: [
            <Adobe key="adobe" />,
            <Figma key="figma" />,
            <Windows key="windows" />,
            <Sketch key="sketch" />
        ],
        buttons: [
            {
                text: "Read More",
                href: FOR_MAC_PATH
            }
        ]
    },
    {
        heading: "Adobe Add-Ins",
        text:
            "Search, grab & modify icons without ever leaving Adobe Illustrator, Photoshop or InDesign (PC/Mac).",
        images: [
            <img src={ILLUSTRATOR_LOGO} alt="" key="illustrator" />,
            <img src={PHOTOSHOP_LOGO} alt="" key="photoshop" />,
            <img src={INDESIGN_LOGO} alt="" key="indesign" />
        ],
        buttons: [
            {
                text: "Read More",
                href: FOR_ADOBE_PATH
            }
        ]
    },
    {
        heading: "Google Add-Ons",
        text:
            "Give Google Slides and Google Docs a quick and easy visual boost with drag and drop vector icons.",
        images: [<GSlides key="slides" />, <GDocs key="docs" />],
        buttons: [
            {
                text: "Read More",
                href: FOR_GOOGLE_PATH
            }
        ]
    },
    {
        heading: "Microsoft Add-Ins",
        text:
            "Get & customize icons within Microsoft PowerPoint and Word without downloading ahead of time.",
        images: [<PowerPoint key="powerpoint" />, <Word key="word" />],
        buttons: [
            {
                text: "Read More",
                href: FOR_OFFICE_PATH
            }
        ]
    }
];
